define(["exports", "react", "styled-components", "polished", "../../themes"], function (_exports, _react, _styledComponents, _polished, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  var alertKinds = {
    success: _themes.defaultTheme.colors.green,
    danger: _themes.defaultTheme.colors.red,
    warning: _themes.defaultTheme.colors.yellow
  };

  var StyledAlert = _styledComponents.default.div.withConfig({
    displayName: "Alert__StyledAlert",
    componentId: "sc-j18spc-0"
  })(["align-items:center;background:", ";border-radius:4px;color:", ";display:flex;font-size:1.6em;line-height:1.5;padding:8px 16px;width:100%;box-icon{fill:currentColor;margin-right:8px;}"], function (_ref) {
    var kind = _ref.kind,
        theme = _ref.theme;
    return (0, _polished.mix)(0.1, alertKinds[kind], theme.colors.white);
  }, function (_ref2) {
    var kind = _ref2.kind;
    return alertKinds[kind];
  });

  var Alert = function Alert(_ref3) {
    var kind = _ref3.kind,
        children = _ref3.children;
    return /*#__PURE__*/_react.default.createElement(StyledAlert, {
      kind: kind,
      role: "alert"
    }, children);
  };

  var _default = Alert;
  _exports.default = _default;
});